var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"text-area",domProps:{"value":_vm.value},on:{"input":_vm.onInput,"change":function($event){return _vm.$emit('change', _vm.value)},"keydown":_vm.onKeyDown}})}
var staticRenderFns = []

export { render, staticRenderFns }